(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maison-advertising-media"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (slider) => {
      if (slider.dataset.initialized === 'true') return;
      slider.dataset.initialized = 'true';

      const track = slider.querySelector('[data-maison-journal-track]');
      const slides = [...slider.querySelectorAll('[data-maison-journal-slide]')];
      const previous = slider.querySelector('[data-maison-journal-prev]');
      const next = slider.querySelector('[data-maison-journal-next]');
      const status = slider.querySelector('[data-maison-journal-status]');
      if (!track || slides.length < 2) return;

      let activeIndex = 0;
      let timer;

      const goTo = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        slides[activeIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        if (status) status.textContent = `${activeIndex + 1} / ${slides.length}`;
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
      };

      const start = () => {
        stop();
        if (slider.dataset.autoplay !== 'true') return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const interval = Number(slider.dataset.interval) || 6000;
        timer = window.setInterval(() => goTo(activeIndex + 1), interval);
      };

      previous?.addEventListener('click', () => {
        goTo(activeIndex - 1);
        start();
      });

      next?.addEventListener('click', () => {
        goTo(activeIndex + 1);
        start();
      });

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      start();
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-maison-journal-slider]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
